export enum PartnerExtIdType {
  Tms = 'TMS_ID',
  Sap = 'SAP_ID',
}

export enum PartnerCustomerExtIdType {
  ShipTo = 'SHIP_TO_ID',
  SoldTo = 'SOLD_TO_ID',
}

export enum PartnerServiceType {
  Tms = 'TMS_ID',
  Sap = 'SAP_ID',
  ShipTo = 'SHIP_TO_ID',
  SoldTo = 'SOLD_TO_ID',
}
